import { render, staticRenderFns } from "./TraineeViewSidebar.vue?vue&type=template&id=30c41054&scoped=true&"
import script from "./TraineeViewSidebar.vue?vue&type=script&lang=js&"
export * from "./TraineeViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TraineeViewSidebar.vue?vue&type=style&index=0&id=30c41054&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c41054",
  null
  
)

export default component.exports